import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";

export default function Login() {
  const { login, register } = useAuth();
  const { lang, langCode, switchLang } = useLang();
  const L = lang.auth;

  const [mode, setMode] = useState("login"); // "login" | "register"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isRegister = mode === "register";

  const handleSubmit = async () => {
    setError("");

    if (!email || !email.includes("@")) {
      setError(L.errorInvalidEmail || "Email invalid.");
      return;
    }
    if (!password || password.length < 8) {
      setError(L.errorShortPassword || "Parola trebuie să aibă minim 8 caractere.");
      return;
    }

    setLoading(true);
    const err = isRegister
      ? await register(email, password, name || undefined)
      : await login(email, password);
    setLoading(false);

    if (err) setError(err);
    // dacă err === null, AuthContext a setat userul → redirect automat din App
  };

  const switchMode = () => {
    setMode(m => m === "login" ? "register" : "login");
    setError("");
    setPassword("");
  };

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 12px",
    border: "0.5px solid #d1d5db",
    borderRadius: 8,
    fontSize: 14,
    fontFamily: "sans-serif",
    marginBottom: 12,
    outline: "none",
  };

  const labelStyle = {
    display: "block",
    fontSize: 13,
    fontWeight: 500,
    marginBottom: 6,
    fontFamily: "sans-serif",
    color: "#374151",
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <div style={{ width: "100%", maxWidth: 400 }}>

        {/* Lang switcher */}
        <div style={{ textAlign: "right", marginBottom: 16 }}>
          {["ro", "en"].map(code => (
            <button key={code} onClick={() => switchLang(code)}
              style={{ marginLeft: 8, padding: "4px 10px", border: "0.5px solid #e5e7eb", borderRadius: 6, background: langCode === code ? "#1d4ed8" : "#fff", color: langCode === code ? "#fff" : "#374151", fontSize: 12, cursor: "pointer", fontFamily: "sans-serif" }}>
              {code.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Card */}
        <div style={{ background: "#fff", border: "0.5px solid #e5e7eb", borderRadius: 12, padding: "32px 28px", boxShadow: "0 1px 8px rgba(0,0,0,0.06)" }}>

          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1d4ed8", margin: "0 0 4px", fontFamily: "Georgia, serif" }}>Narratiq</h1>
            <p style={{ fontSize: 12, color: "#9ca3af", margin: 0, fontFamily: "sans-serif" }}>EditorialAI România</p>
          </div>

          {/* Titlu dinamic */}
          <h2 style={{ fontSize: 18, fontWeight: 600, margin: "0 0 4px", fontFamily: "sans-serif" }}>
            {isRegister ? (L.registerTitle || "Creează cont") : (L.title || "Autentificare")}
          </h2>
          <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 20px", fontFamily: "sans-serif" }}>
            {isRegister ? (L.registerSubtitle || "Completează datele de mai jos.") : (L.subtitle || "Intră în contul tău Narratiq.")}
          </p>

          {/* Nume (doar la register) */}
          {isRegister && (
            <>
              <label style={labelStyle}>{L.nameLabel || "Nume (opțional)"}</label>
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder={L.namePh || "Ion Popescu"}
                style={inputStyle}
              />
            </>
          )}

          {/* Email */}
          <label style={labelStyle}>{L.emailLabel || "Email"}</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleSubmit()}
            placeholder={L.emailPh || "email@exemplu.ro"}
            style={inputStyle}
          />

          {/* Parolă */}
          <label style={labelStyle}>{L.passwordLabel || "Parolă"}</label>
          <div style={{ position: "relative", marginBottom: 12 }}>
            <input
              type={showPass ? "text" : "password"}
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
              placeholder={isRegister ? (L.passwordPhNew || "Minim 8 caractere") : (L.passwordPh || "Parola ta")}
              style={{ ...inputStyle, marginBottom: 0, paddingRight: 44 }}
            />
            <button
              onClick={() => setShowPass(s => !s)}
              style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 13, fontFamily: "sans-serif", padding: 0 }}>
              {showPass ? (L.hidePass || "Ascunde") : (L.showPass || "Arată")}
            </button>
          </div>

          {/* Eroare */}
          {error && (
            <p style={{ fontSize: 12, color: "#dc2626", margin: "0 0 10px", fontFamily: "sans-serif" }}>{error}</p>
          )}

          {/* Submit */}
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{ width: "100%", padding: "11px 0", background: loading ? "#93c5fd" : "#1d4ed8", color: "#fff", border: "none", borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: loading ? "not-allowed" : "pointer", fontFamily: "sans-serif", marginBottom: 16 }}>
            {loading
              ? (L.btnLoading || "Se procesează...")
              : isRegister
                ? (L.btnRegister || "Creează cont")
                : (L.btnLogin || "Intră în cont")}
          </button>

          {/* Switch mode */}
          <p style={{ fontSize: 13, color: "#6b7280", textAlign: "center", margin: 0, fontFamily: "sans-serif" }}>
            {isRegister
              ? (L.alreadyHaveAccount || "Ai deja cont?")
              : (L.noAccount || "Nu ai cont?")}
            {" "}
            <button
              onClick={switchMode}
              style={{ color: "#1d4ed8", background: "none", border: "none", cursor: "pointer", fontSize: 13, fontFamily: "sans-serif", fontWeight: 500, padding: 0 }}>
              {isRegister ? (L.switchToLogin || "Autentifică-te") : (L.switchToRegister || "Înregistrează-te")}
            </button>
          </p>
        </div>

        <p style={{ fontSize: 11, color: "#9ca3af", textAlign: "center", marginTop: 16, fontFamily: "sans-serif" }}>
          {lang.common?.footerNote}
        </p>
      </div>
    </div>
  );
}
